module.exports = __webpack_public_path__ + "media/images/quality-banner-849130dcc050c81005c7027adb7f10e6.jpg";